// The default height (in pixels) for a row
export const ROW_DEFAULT_HEIGHT = 26;
